import React from 'react';
import styles from './SocialButtonsList.scss';
import { IconButton } from '../IconButton/IconButton';
import classNames from 'classnames';
import { emailIcon } from '@justgiving/icons';
import Svg from '@justgiving/svg';
import { useShareContext } from '../../context/ShareContext';

interface EmailShareRoundProps {
  className?: string;
  onClick?: () => void;
}

export const EmailShareRound: React.FunctionComponent<EmailShareRoundProps> = ({
  className,
  onClick = () => {},
}) => {
  const { shareItems } = useShareContext();

  const linkItemClick = () => {
    onClick();
  };

  return (
    <IconButton className={`${styles.roundButton} ${className}`}>
      <a
        href={`mailto:?subject=${encodeURIComponent(
          shareItems.email.subject,
        )}&body=${encodeURIComponent(shareItems.email.body)}`}
        data-qa="email"
        onClick={linkItemClick}
      >
        <div className={classNames(styles.iconWrapper, styles.email)}>
          <Svg markup={emailIcon} className={styles.icon} />
        </div>
        Email
      </a>
    </IconButton>
  );
};
